import { render, staticRenderFns } from "./registered-coach-pool.vue?vue&type=template&id=846d0968&scoped=true&"
import script from "./registered-coach-pool.vue?vue&type=script&lang=js&"
export * from "./registered-coach-pool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846d0968",
  null
  
)

export default component.exports